import { createRouter, createWebHistory } from "vue-router";
import LandingPage from "@/app/views/LandingPage.vue";
import MoreInfo from "@/app/views/MoreInfo.vue";
import ImpressumPage from "@/app/views/ImpressumPage.vue";
import DatenschutzPage from "@/app/views/DatenschutzPage.vue";

export const SITE_URL = "https://therapie-eltville.de";

export const ROUTES = {
  START: "/",
  MORE_INFO: "/ueberUns",
  IMPRESSUM: "/impressum",
  DATENSCHUTZ: "/datenschutz",
};

const routes = [
  {
    path: ROUTES.START,
    name: "landingPage",
    component: LandingPage,
    meta: {
      backgroundImage: require("@/assets/images/TransparenterHintergrund2.webp"),
      title: "Heilpraktikerin für Psychotherapie in Eltville | Astrid Jung",
      description:
        "Psychotherapeutische Praxis (HeilPrG) von Astrid Jung in Eltville-Hattenheim. EMDR, Traumatherapie, systemische Therapie und Hypnotherapie im Rheingau.",
    },
  },
  {
    path: ROUTES.MORE_INFO,
    name: "moreInfo",
    component: MoreInfo,
    meta: {
      backgroundImage: require("@/assets/images/TransparenterHintergrund2.webp"),
      title: "Angebot, Methoden & Kontakt | Praxis Astrid Jung, Eltville",
      description:
        "Behandlungsschwerpunkte, Methoden, Praxisräume und Kontakt der psychotherapeutischen Praxis (HeilPrG) Astrid Jung in Eltville-Hattenheim im Rheingau.",
    },
  },
  {
    path: ROUTES.IMPRESSUM,
    name: "impressum",
    component: ImpressumPage,
    meta: {
      backgroundImage: require("@/assets/images/TransparenterHintergrund1.webp"),
      title: "Impressum | Therapie Eltville",
      description:
        "Impressum und Anbieterkennzeichnung der psychotherapeutischen Praxis (HeilPrG) Astrid Jung, Eisenbahnstraße 6, 65347 Eltville-Hattenheim.",
    },
  },
  {
    path: ROUTES.DATENSCHUTZ,
    name: "datenschutz",
    component: DatenschutzPage,
    meta: {
      backgroundImage: require("@/assets/images/TransparenterHintergrund1.webp"),
      title: "Datenschutzerklärung | Therapie Eltville",
      description:
        "Informationen zur Verarbeitung personenbezogener Daten auf therapie-eltville.de nach DSGVO.",
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

/**
 * Setzt oder aktualisiert ein <meta>-Tag im <head>.
 * @param {string} attr - "name" oder "property"
 * @param {string} key - Wert des Attributs, z. B. "description"
 * @param {string} content
 */
function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

router.afterEach((to) => {
  const { title, description } = to.meta;
  const url = SITE_URL + (to.path === ROUTES.START ? "/" : to.path);

  if (title) {
    document.title = title;
    setMeta("property", "og:title", title);
  }
  if (description) {
    setMeta("name", "description", description);
    setMeta("property", "og:description", description);
  }
  setMeta("property", "og:url", url);

  let canonical = document.head.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", url);
});

export default router;
